import { gql } from "@apollo/client";

export const getLensSourceListEnabled = gql`
    query getLensSourceListEnabled($organizationId: String = null) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        getLensSourceListEnabled(input: { organizationId: $organizationId }) {
            lensSourceMap {
                lensSourceList {
                    id
                    name
                    externalId
                }
                lensSourceType
            }
        }
    }
`;
